import { Badge } from 'components/Badge/Badge'
import { useTheme } from 'styled-components'
import { ColorVariant, Flex } from 'styling/GlobalStyles'
import { MediumText, SmallText } from 'styling/TypographyV2'
import { IOperationalSite, SiteStatus } from 'features/operationalManagement/operationalManagement.types'
import { SiteRow } from '../Organogram.styled'

export const SiteAtGlanceCard = ({ site }: { site: IOperationalSite }) => {
  const theme = useTheme() as any
  const isActive = site.status === SiteStatus.Active
  const accent = isActive ? theme.colorGreen : theme.greyText

  return (
    <SiteRow accentColor={accent}>
      <Flex center gap='0.5rem'>
        <MediumText bold>{site.name}</MediumText>
        <Badge hexColor={accent}>{isActive ? 'Active' : 'Inactive'}</Badge>
      </Flex>
      <SmallText colorVariant={ColorVariant.SECONDARY}>
        {site.teamCount} {site.teamCount === 1 ? 'team' : 'teams'} · {site.memberCount} assigned
      </SmallText>
    </SiteRow>
  )
}
